<template>
  <div>
    <el-dialog title="Nueva matrícula" :visible.sync="dialogVisible" :before-close="handleCancel">
      <el-form ref="enrolmentForm" :model="enrolment" label-position="top">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Fecha" prop="staff_id">
              <el-date-picker
                v-model="enrolment.date"
                type="date"
                placeholder="Seleccionar fecha"
                format="dd/MM/yyyy"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Curso">
              <el-input :value="timetable.course_name" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Horario">
              <el-input :value="timetable.start + ' - ' + timetable.finish" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Estudiante" required>
              <el-select v-model="enrolment.user_id" filterable placeholder="Seleccionar estudiante">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.fullname"
                  :value="user.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Tarifa" required>
              <el-select v-model="enrolment.fare_id" placeholder="Seleccionar tarifa">
                <el-option
                  v-for="fare in fares"
                  :key="fare.id"
                  :label="fare.name"
                  :value="fare.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Creación">
              <el-checkbox switch size="lg" v-model="enrolment.fact_type" border> 
                Automática
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="enrolment.fact_type">
          <el-col :span="8">
            <el-form-item label="Intervalos de facturas" required>
              <el-select v-model="enrolment.period_id" filterable placeholder="Seleccionar intervalo">
                <el-option
                  v-for="(period, key) in {
                    0: 'Mensual',
                    1: 'Trimestral',
                    2: 'Único'
                  }"
                  :key="key"
                  :label="period"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Fecha fin de automatización" required>
              <el-date-picker
                v-model="enrolment.date_finish"
                type="date"
                placeholder="Pick a day">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Email">
              <el-checkbox switch size="lg" v-model="enrolment.send_email" border> 
                Enviar automáticamente
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">Cancelar</el-button>
        <el-button type="primary" @click="handleSubmit()">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['dialogVisible', 'timetable_id'],
    data() {
      return {
        enrolment: {
          date: new Date(),
          user_id: null,
          course_id: null,
          fare_id: null,
          timetable_id: null,
          fact_type: false,
          period_id: null,
          date_finish: null,
          send_email: false,
        },
        timetable: {},
        users: [],
        fares: [],
      }
    },
    created() {
      this.getTimetable();
      this.fetchStudents();
    },
    methods: {
      handleCancel(done) {
        this.$emit('dialogVisible', false);
      },
      getTimetable() {
        axios.get(`/timetables-json/${this.timetable_id}`)
        .then(res => {
          this.timetable = res.data.data;
          this.enrolment.course_id = this.timetable.course_id;
          this.enrolment.timetable_id = parseInt(this.timetable_id);
          this.fetchFares(this.timetable.course_id);
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      fetchStudents() {
        axios.get('/students-list-json')
        .then(res => {
          this.users = res.data;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      fetchFares(course_id) {
        axios.get(`/get-fares-course/${course_id}`)
        .then(res => {
          this.fares = res.data;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleSubmit() {
        if (!this.enrolment.user_id || !this.enrolment.fare_id) {
          alert("Los campos 'Estudiante' y 'Tarifa' son obligatorios")
          return;
        }
        if (this.enrolment.fact_type) {
          if (!this.enrolment.period_id || !this.enrolment.date_finish) {
            alert("Los campos 'Intervalos de facturas' y 'Fecha fin de automatización' son obligatorios")
            return;
          }
        }
        axios.post('/enrolments-json', this.enrolment)
        .then(res => {
          this.handleCancel();
        })
        .catch(e => {
          console.log(e.response);
        })
      }
    },
  }
</script>
<style scoped>
  .v-modal {
    z-index: 0 !important;
  }
</style>